// Lien interne : visite Inertia (pas de rechargement), préchargée au survol.
// Rend un <a> identique à celui de link_to.
//
// prefetch={false} pour un lien dont la cible a un effet de bord sur GET.
// Pour un lien qui doit recharger toute la page (paiement, déconnexion,
// téléchargement, page hors du front React), écrire un <a> simple.
import { Link } from '@inertiajs/react'
import type { ComponentProps } from 'react'

type Props = ComponentProps<typeof Link>

export default function AppLink({ prefetch = 'hover', ...props }: Props) {
  return <Link prefetch={prefetch} {...props} />
}
